import { render } from "./CLoading.vue?vue&type=template&id=2a13be7e&scoped=true"
const script = {}

import "./CLoading.vue?vue&type=style&index=0&id=2a13be7e&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ldcloud\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a13be7e"]])

export default __exports__